import { render, staticRenderFns } from "./order-create-product.vue?vue&type=template&id=1f54deec&"
import script from "./order-create-product.ts?vue&type=script&lang=ts&"
export * from "./order-create-product.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports